export default __webpack_public_path__ + "static/media/E4.29788e37.mp3";